import { render } from "./ModalMatchManager.vue?vue&type=template&id=d0c5c212&scoped=true"
import script from "./ModalMatchManager.vue?vue&type=script&lang=js"
export * from "./ModalMatchManager.vue?vue&type=script&lang=js"

import "./ModalMatchManager.vue?vue&type=style&index=0&id=d0c5c212&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d0c5c212"

export default script